import { render, staticRenderFns } from "./MachineViewBuy.vue?vue&type=template&id=34c4c322&"
import script from "./MachineViewBuy.vue?vue&type=script&lang=js&"
export * from "./MachineViewBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports